import * as React from "react";
import { SVGProps } from "react";

const QuestionMarkCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 886.926 886.926"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "auto",
      fillRule: "evenodd",
      clipRule: "evenodd"
    }}
    {...props}
  >
    <circle
      cx="443.463"
      cy="443.463"
      r="400"
      fill="#FFFFFF"
      stroke="#000000"
      strokeWidth="70"
      style={{
        opacity: 1
      }}
    />
    <path
      fill="#000000"
      d="M443.463 200c-80.5 0-146.25 65.75-146.25 146.25h70c0-42.1 34.15-76.25 76.25-76.25s76.25 34.15 76.25 76.25c0 42.1-34.15 76.25-76.25 76.25-27.61 0-50 22.39-50 50v50h70v-30c68.4-12.65 120-73.1 120-146.25 0-80.5-65.75-146.25-146.25-146.25Z"
      style={{
        opacity: 1
      }}
    />
    <circle
      cx="443.463"
      cy="625"
      r="40"
      fill="#000000"
      style={{
        opacity: 1
      }}
    />
  </svg>
);

export default QuestionMarkCircle;